import React from "react";
import './style.scss'
const SectionTitle = ({ subTitle, title, infoTeam }) => {
    return (
        <div className="sectionTitle">
            <span>{subTitle}</span>
            <h2>{title}</h2>
            <p>{infoTeam}</p>
        </div>
    )
}
export default SectionTitle